import { render } from "./UploadProfilePhoto.vue?vue&type=template&id=1ebbe76e&scoped=true"
import script from "./UploadProfilePhoto.vue?vue&type=script&lang=js"
export * from "./UploadProfilePhoto.vue?vue&type=script&lang=js"

import "./UploadProfilePhoto.vue?vue&type=style&index=0&id=1ebbe76e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebbe76e"]])

export default __exports__